/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext, useMemo, useRef } from 'react'
import { message, Spin } from 'antd'
import classNames from 'classnames'
import { useUpdate } from 'ahooks'
import LoadMore from '../../loadmore'
import Pro2 from '../../../image/detail/pro2.png'
import emptyBgImage from '../../../image/empty.png'
import Empty from '../../../baseComponent/empty'
import Icon from '../../icon'
import replaceHandle from '../../../common/replaceHandle'
import Checkbox from '../../../baseComponent/checkbox'
import Radio from '../../../baseComponent/radio'
import { InspirationTreeList } from '../context'
import './index.less'

const cover = (item) => item?.coverImgUrl || item?.lastBlogList?.[0]?.mainUrl

export default ({ loading, data, onLoad, isEnd = true, scrollHeight, onNext, value, onChange, currentOptionItem }) => {
  const listRef = useRef(null)
  const _inspirationContext = useContext(InspirationTreeList)
  return <Spin spinning={loading}>
    <div ref={listRef} className="tree-list" style={{ height: scrollHeight }}>
      {
      currentOptionItem || data.length ? <>
        {
        data.map(item => <TreeItem
          item={item}
          onNext={onNext}
          value={value}
          onChange={onChange}
          onCancelCollect={_inspirationContext.onCancelCollect}
          onItemCollect={_inspirationContext.onItemCollect}
          singleCollection={_inspirationContext.singleCollection}
        />)
    }
        <LoadMore onLoad={onLoad} stop={isEnd} loading={loading} observerParams={{ root: listRef.current }}>
          {loading ? <div style={{ height: 48, textAlign: 'center', paddingTop: 10 }}>加载中...</div> : null}
        </LoadMore>
      </>
        : <Empty title="暂无相关灵感集" type="ins" style={{ paddingTop: '80px' }} />
    }
    </div>
  </Spin>
}

export const SearchTreeList = ({ parentData, allChildData, keyWords, scrollHeight, onNext, value, onChange }) => {
  const _inspirationContext = useContext(InspirationTreeList)
  return <div className={classNames('tree-list-keyWords', 'tree-list')} style={{ height: scrollHeight + 38 }}>
    <div className="tree-list-keyWords-tab">
      含有“<div className="text-overflow" style={{ maxWidth: '140px' }}>{keyWords}</div>”的灵感集
    </div>
    {parentData.length || allChildData.length ? <>
      {
        parentData.map(item => <TreeItem
          item={item}
          keyWords={keyWords}
          onNext={(...arg) => onNext(...arg, `含有"${keyWords}"的灵感集`, keyWords)}
          value={value}
          onChange={onChange}
          onCancelCollect={_inspirationContext.onCancelCollect}
          onItemCollect={_inspirationContext.onItemCollect}
          singleCollection={_inspirationContext.singleCollection}
        />)
    }
      <div className="tree-list-keyWords-chid-tab">
        含有“<div className="text-overflow" style={{ maxWidth: '140px' }}>{keyWords}</div>”的子灵感集
      </div>
      {
        allChildData.map(item => <TreeItem
          item={item}
          keyWords={keyWords}
          onNext={(...arg) => onNext(...arg, `含有"${keyWords}”的子灵感集`, keyWords)}
          value={value}
          onChange={onChange}
          onCancelCollect={_inspirationContext.onCancelCollect}
          onItemCollect={_inspirationContext.onItemCollect}
          singleCollection={_inspirationContext.singleCollection}
        />)
    }
    </> : <Empty title="暂无相关灵感集" type="ins" style={{ paddingTop: '80px' }} />}

  </div>
}

export const TreeParentList = ({ data, scrollHeight, onNext, value, onChange, loading }) => {
  const _inspirationContext = useContext(InspirationTreeList)
  return <Spin spinning={loading}>
    <div className="tree-list" style={{ height: scrollHeight }}>
      {
        data && <div>
          <TreeItem
            item={data}
            isNext={false}
            onChange={onChange}
            value={value}
            onCancelCollect={_inspirationContext.onCancelCollect}
            onItemCollect={_inspirationContext.onItemCollect}
            singleCollection={_inspirationContext.singleCollection}
          />
          <div style={{ margin: '16px 0px 8px 8px', color: 'var(--m-text-3)', fontSize: '12px' }}>子灵感集</div>
            {
                data.childs.map(item => <TreeItem
                  item={item}
                  value={value}
                  onChange={onChange}
                  onNext={onNext}
                  onCancelCollect={_inspirationContext.onCancelCollect}
                  onItemCollect={_inspirationContext.onItemCollect}
                  singleCollection={_inspirationContext.singleCollection}
                />)
            }
        </div>
    }
    </div>
  </Spin>
}

const TreeItem = ({
  item,
  onNext,
  isNext = true,
  keyWords,
  value,
  onChange,
  onCancelCollect,
  onItemCollect,
  singleCollection,
  style,
}) => {
  const _inspirationContext = useContext(InspirationTreeList)
  const isMultiple = Array.isArray(value)
  const onUpdate = useUpdate()
  const _onChange = (e) => {
    e?.stopPropagation()
    if (item.disabled && !item.checked) {
      message.info('该灵感集空间不足，请选择其他灵感集或创建新灵感集')
      return
    }
    if (item.currentCollectFlag || singleCollection) {
      return
    }
    if (isMultiple) {
      const checked = value.some(i => i === item.value)
      if (!checked) {
        item.checked = true
        onChange(true, item)
      } else {
        item.checked = false
        onChange(false, item)
      }
    } else {
      onChange(true, item)
    }
  }

  const _onCancelCollect = () => {
    item.currentCollectFlag = 0
    item.checked = false
    onCancelCollect?.(item.value, item)
    onUpdate()
  }

  const _onItemCollect = () => {
    const success = onItemCollect?.(item.value, item)
    if (success === false) {
      return
    }
    if (_inspirationContext.hasCollectChange) {
      item.currentCollectFlag = 1
    }
    onUpdate()
  }

  const multDisabled = useMemo(() => {
    if (item.currentCollectFlag) {
      return true
    }
    return item.disabled
  }, [item.currentCollectFlag, item.disabled])

  return <div className="tree-list-item" key={item.id} style={style} onClick={_onChange}>
    {
      !singleCollection ? isMultiple ? <Checkbox
        disabled={multDisabled}
        checked={item.checked}
        style={{ marginRight: '16px' }}
        onClick={(e) => e.stopPropagation()}
        onChange={() => {
          _onChange()
        }}
      /> : <Radio
        checked={value === item.value}
        style={{ marginRight: '16px' }}
      /> : null
    }
    <div
      className="item-cover"
      style={{ background: `url(${cover(item)}) center/cover no-repeat` }}
    >
      { !cover(item) && <div className="item-cover-empty-icon">
        <img style={{ width: '24px' }} src={emptyBgImage} alt="" />
        </div>}
    </div>
    <div className="item-title">
      <div className="item-title-top">
        <span
          className="inspiration-title"
        >
          {item.isPro === 1 && <img src={Pro2} className="coll-info-img" />}
          <div className="inspiration-title-text text-overflow" dangerouslySetInnerHTML={{ __html: replaceHandle(item.name, keyWords) }} />
        </span>
      </div>
      <div className="item-title-info">
        <div className="item-username text-overflow">
          {item.ownerName}
        </div>
        {
          !!item.blogNumLimit && !item.parent && <div className="item-title-num-hover">
            <div className="item-title-info-line" />
            <div className="item-num">
              款式数量：{item.blogNum}/{item.blogNumLimit}
            </div>
          </div>
        }
      </div>
    </div>
    {
      item.currentCollectFlag ? <div
        className="tree-list-item-cancel-collect"
        style={{ right: !(!!item.childs?.length && isNext) && 0 }}
        onClick={(e) => {
          e.stopPropagation()
          _onCancelCollect?.()
        }}
      >
        取消采集
      </div> : <>
        {
        singleCollection && <div
          className={classNames('tree-list-item-collect', { disabled: item.disabled && !item.checked })}
          style={{ right: !(!!item.childs?.length && isNext) && 0 }}
          onClick={(e) => {
            e.stopPropagation()
            if (item.disabled && !item.checked) {
              message.info('该灵感集空间不足，请选择其他灵感集或创建新灵感集')
            } else {
              _onItemCollect?.()
            }
          }}
        >
          {_inspirationContext.collectBtn}
        </div>
      }
      </>
    }
    {
      !!item.childs?.length && isNext && <div
        className="tree-list-item-next-btn"
        onClick={(e) => {
          e.stopPropagation()
          onNext(item.childs, item)
        }}
      >
        <Icon type="m-Vxing_you" />
        {
          item.indeterminate && <div className="tree-list-item-next-btn-point" />
        }
      </div>
  }
  </div>
}
